export default __webpack_public_path__ + "navigation-examples-embedded-navigation-v1-960-d7292568c4f0909b2acce0e692065843.png";